import React, { useState } from 'react';
import './FloatingButtons.css';

const WHATSAPP_NUMBER  = '919989346471';
const WHATSAPP_MESSAGE = 'Hello! I would like to book an appointment at TheOrthomed.';

/* ── Proper WhatsApp icon SVG ── */
function WhatsAppIcon({ size = 40 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width={size}
      height={size}
    >
      {/* Green circle background */}
      <circle cx="24" cy="24" r="24" fill="#25D366" />
      {/* Official WhatsApp phone handset shape */}
      <path
        fill="#ffffff"
        d="M24 9C15.716 9 9 15.716 9 24c0 2.628.687 5.1 1.888 7.243L9 39l7.978-1.862A14.938 14.938 0 0 0 24 39c8.284 0 15-6.716 15-15S32.284 9 24 9zm0 2c7.18 0 13 5.82 13 13s-5.82 13-13 13a12.95 12.95 0 0 1-6.54-1.766l-.468-.28-4.732 1.107 1.138-4.607-.308-.493A12.94 12.94 0 0 1 11 24c0-7.18 5.82-13 13-13zm-4.142 6.528c-.22-.496-.45-.506-.658-.515-.171-.008-.366-.007-.561-.007s-.512.074-.78.367c-.269.293-1.025 1.001-1.025 2.44 0 1.44 1.05 2.83 1.196 3.025.147.195 2.025 3.23 5 4.394.695.267 1.238.427 1.661.547.698.198 1.333.17 1.835.103.56-.075 1.722-.703 1.965-1.382.244-.68.244-1.263.17-1.383-.073-.12-.268-.195-.561-.341-.293-.147-1.733-.855-2.001-.952-.268-.098-.463-.147-.659.147-.195.293-.757.952-.927 1.147-.17.195-.342.22-.635.073-.293-.147-1.237-.456-2.356-1.454-.87-.776-1.457-1.734-1.628-2.027-.17-.293-.018-.452.128-.598.13-.13.293-.341.44-.512.146-.17.194-.293.292-.488.098-.195.049-.366-.025-.513-.073-.146-.637-1.596-.876-2.181z"
      />
    </svg>
  );
}

export default function FloatingButtons() {
  const [chatOpen,  setChatOpen]  = useState(false);
  const [chatStep,  setChatStep]  = useState(0);
  const [userName,  setUserName]  = useState('');
  const [userPhone, setUserPhone] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const whatsappURL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  const closeChat = () => {
    setChatOpen(false);
    setChatStep(0);
    setUserName('');
    setUserPhone('');
    setSubmitted(false);
  };

  const handleChatSubmit = () => {
    if (userName && userPhone) {
      setSubmitted(true);
      const msg = `Hi! I'm ${userName} (${userPhone}). I'd like to book an appointment at TheOrthomed.`;
      setTimeout(() => {
        window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`, '_blank');
        closeChat();
      }, 2000);
    }
  };

  return (
    <>
      {/* ── LEFT SIDE TAB ── */}
      <button className="chat-tab" onClick={() => setChatOpen(true)} aria-label="Chat with us">
        <WhatsAppIcon size={18} />
        <span className="chat-tab-text">Chat With Us</span>
      </button>

      {/* ── WHATSAPP FLOATING BUTTON — bottom right ── */}
      <a
        href={whatsappURL}
        target="_blank"
        rel="noreferrer"
        className="wa-btn"
        aria-label="Chat on WhatsApp"
      >
        <WhatsAppIcon size={44} />
        <div className="wa-pulse" />
      </a>

      {/* ── CHAT POPUP ── */}
      {chatOpen && (
        <div className="chat-popup">

          {/* Header */}
          <div className="chat-header">
            <div className="chat-header-left">
              <div className="chat-avatar">
                <WhatsAppIcon size={36} />
              </div>
              <div>
                <div className="chat-title">TheOrthomed</div>
                <div className="chat-status">
                  <span className="chat-online-dot" />
                  Online — Replies Instantly
                </div>
              </div>
            </div>
            <button className="chat-close" onClick={closeChat}>✕</button>
          </div>

          {/* Body */}
          <div className="chat-body">
            {submitted ? (
              <div className="chat-submitted">
                <div style={{ fontSize: 44, marginBottom: 12 }}>✅</div>
                <div style={{ fontWeight: 700, color: '#0F1C2E', marginBottom: 8 }}>
                  Thanks, {userName}!
                </div>
                <div style={{ fontSize: 13.5, color: '#475569', lineHeight: 1.6 }}>
                  Connecting you to WhatsApp now...
                </div>
              </div>
            ) : (
              <>
                {/* Bot greeting */}
                <div className="chat-msg bot">
                  <div className="chat-bubble">
                    👋 Hi! Welcome to <strong>TheOrthomed</strong>.<br /><br />
                    I'm here to help you book an appointment with{' '}
                    <strong>Dr. Geetha</strong> or <strong>Dr. Sadhan</strong>.<br /><br />
                    Please share your details and we'll get back to you right away!
                  </div>
                </div>

                {/* Step 0 — quick replies */}
                {chatStep === 0 && (
                  <div className="chat-quick-replies">
                    <button onClick={() => setChatStep(1)}>📅 Book Appointment</button>
                    <button onClick={() => window.open(whatsappURL, '_blank')}>
                      💬 Chat on WhatsApp
                    </button>
                    <button onClick={() => window.open('tel:+919989346471')}>
                      📞 Call Us Now
                    </button>
                  </div>
                )}

                {/* Step 1 — name + phone */}
                {chatStep === 1 && (
                  <>
                    <div className="chat-msg bot">
                      <div className="chat-bubble">Please enter your details below:</div>
                    </div>
                    <div className="chat-input-group">
                      <input
                        className="chat-input"
                        placeholder="Your Full Name"
                        value={userName}
                        onChange={e => setUserName(e.target.value)}
                      />
                      <input
                        className="chat-input"
                        type="tel"
                        placeholder="Phone Number (+91...)"
                        value={userPhone}
                        onChange={e => setUserPhone(e.target.value)}
                      />
                      <button
                        className="chat-send-btn"
                        onClick={handleChatSubmit}
                        disabled={!userName || !userPhone}
                      >
                        <WhatsAppIcon size={18} />
                        Send on WhatsApp →
                      </button>
                    </div>
                  </>
                )}
              </>
            )}
          </div>

          {/* Footer */}
          <div className="chat-footer">
            <WhatsAppIcon size={16} />
            <span>Powered by WhatsApp · +91 99893 46471</span>
          </div>

        </div>
      )}
    </>
  );
}